import { render, staticRenderFns } from "./SponsoringDetails.vue?vue&type=template&id=645a8d42&scoped=true"
import script from "./SponsoringDetails.vue?vue&type=script&lang=js"
export * from "./SponsoringDetails.vue?vue&type=script&lang=js"
import style0 from "./SponsoringDetails.vue?vue&type=style&index=0&id=645a8d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645a8d42",
  null
  
)

export default component.exports